import React, { useState } from "react";
import { FaPlus } from "react-icons/fa6";

export default function FAQSection({ faqs }) {
  const [activeFAQ, setActiveFAQ] = useState(null);

  const toggleFAQ = (index) => {
    setActiveFAQ((prev) => (prev === index ? null : index));
  };
  return (
    <div className="bg-gray-50 py-5">
      <div className="faq">
        <h2 className="text-3xl font-bold text-center mb-5"> Faqs</h2>
        <ul className="faq-list">
          {faqs.map((faq, index) => (
            <li
              key={index}
              data-aos="fade-up"
              data-aos-delay={100 * (index + 1)}
              className={`aos-init aos-animate ${
                activeFAQ === index ? "open" : ""
              }`}
            >
              <button
                className="faq-toggle"
                onClick={() => toggleFAQ(index)}
                aria-expanded={activeFAQ === index}
              >
                {faq.question}{" "}
                <FaPlus
                  className={`fas fa-arrow-up ${
                    activeFAQ === index ? "rotate" : ""
                  }`}
                />
              </button>
              <div id={`faq${index}`} className="collapse">
                {activeFAQ === index && <p>{faq.answer}</p>}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
